import React, { Component } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import { Message } from 'jl-design-system/components/message/v2/Message';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import { connect } from 'react-redux';
import { auth0Login } from '../../redux/actions/bff/bffActions';
// components
import PartnerDiscountInvalidMessage from '../partner-discount-invalid-message/PartnerDiscountInvalidMessage';
// styles
import styles from './pos-credit-session-expired-error.scss';

export class PosCreditSessionExpiredError extends Component {
  static propTypes = {
    auth0Login: PropTypes.func,
    handleButtonClick: PropTypes.func,
    isInvalidPartnerDiscount: PropTypes.bool,
    isLoginRequired: PropTypes.bool,
  };

  static defaultProps = {
    auth0Login: window.defaultFunc,
    handleButtonClick: window.defaultFunc,
    isInvalidPartnerDiscount: false,
    isLoginRequired: false,
  };

  messageTitle = () => {
    const { isLoginRequired } = this.props;
    return isLoginRequired ? 'You haven’t successfully completed your payment plan'
      : 'Sorry, we have been unable to place your order';
  }

  onClick = () => {
    const { isLoginRequired, auth0Login, handleButtonClick } = this.props;
    return isLoginRequired ? auth0Login() : handleButtonClick();
  }

  buttonLabel = () => {
    const { isLoginRequired } = this.props;
    return isLoginRequired ? 'Login' : 'Back to basket';
  }

  render() {
    const { isInvalidPartnerDiscount } = this.props;

    return (
      <div className={styles.container}>
        {
          isInvalidPartnerDiscount &&
          <PartnerDiscountInvalidMessage />
        }
        {
          !isInvalidPartnerDiscount &&
          <>
            <Message
              body="If you have made an application, we have cancelled your payment plan with Creation Consumer Finance Ltd"
              className={styles.message}
              title={this.messageTitle()}
              type="error"
              whiteBackground
            />
            <PrimaryButton
              onClick={this.onClick}
            >
              {this.buttonLabel()}
            </PrimaryButton>
          </>
        }
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    isLoginRequired: state.app.isLoginRequired,
  };
}

export function mapDispatchToProps() {
  return {
    auth0Login,
  };
}

export default connect(state => mapStateToProps(state), mapDispatchToProps())(PosCreditSessionExpiredError);
